module.exports = __webpack_public_path__ + "static/drywall-678b15816fd08f74f779701e76d739cf.png";